import "./App.css";
import CryptoDashboard from "./components/CryptoDashboard";

function App() {
  return <CryptoDashboard />;
}

export default App;
